import * as Sentry from '@sentry/react';
import { v4 } from 'uuid';

let listeners = [];

const handleMessage = (messageEvent) => {
  // TODO: Secure this by origin.
  // if (evt.origin !== V2IframeService.getv2iFrameUrl()) {
  //   return;
  // }
  if (!messageEvent || !messageEvent.data) {
    return;
  }
  let parsedMessage;
  try {
    parsedMessage = JSON.parse(messageEvent.data);
  } catch {
    parsedMessage = {};
  }

  if (!parsedMessage.eventType) {
    return;
  }
  Sentry.addBreadcrumb({
    category: 'postMessage',
    message: parsedMessage.eventType,
    level: 'info',
    data: parsedMessage,
  });
  listeners.forEach((listener) => listener.callback(parsedMessage));
};

const unsubscribeFromMessages = (listener) => {
  listeners = listeners.filter((l) => l.id === listener?.id);
};

export const listenToMessages = (callback) => {
  const listener = {
    id: v4(),
    callback,
  };

  listeners.push(listener);
  return () => unsubscribeFromMessages(listener);
};

window.addEventListener('message', handleMessage, false);
